import React, {useRef, useMemo} from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { useImmerReducer  } from "use-immer";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import {MPopper} from "components/Shared";
import MScorecardChart from "components/Shared/MScorecard/MScorecardChart";
import MScorecardBreakdown from "components/Shared/MScorecard/MScorecardBreakdown";

const useStyles = makeStyles(({spacing}) => ({
  Content: {
    display: "flex",
  },
  Metrics: {
    margin: "auto",
    marginRight: 0,
  },
  Metric: {
    display: "flex",
    paddingLeft: spacing(1),
    paddingRight: spacing(1),
  },
  MetricValue: {
    paddingLeft: spacing(.5),
  },
}));

const OPEN_CHARTS = "OPEN_CHARTS";
const CLOSE_CHARTS = "CLOSE_CHARTS";
const OPEN_BREAKDOWN = "OPEN_BREAKDOWN";
const CLOSE_BREAKDOWN = "CLOSE_BREAKDOWN";

const reducer = (draft, {type}) => {
  switch(type) {
    case OPEN_CHARTS:
      draft.chartsOpen = true;
      draft.breakdownOpen = false;
      return;
    case CLOSE_CHARTS:
      draft.chartsOpen = false;
      return;
    case OPEN_BREAKDOWN:
        draft.breakdownOpen = true;
        draft.chartsOpen = false;
      return;
    case CLOSE_BREAKDOWN:
      draft.breakdownOpen = false;
  }
};

const MScorecard = ({metric}) => {
  const {value, label, category, score} = metric;
  const anchorEl = useRef(null);
  const classes = useStyles({anchorEl});
  const [{chartsOpen, breakdownOpen}, localDispatch] = useImmerReducer(reducer, { chartsOpen: false, breakdownOpen: false});
  const {valuePrefix, valueSuffix} = useMemo(() => {switch(label) {
    case "Time in Field Services":
    case "Time in QA":
      return ({
        valuePrefix: "Averaged ",
        valueSuffix: " Days",
      });
    case "Mueller Rep Violations":
      return ({
        valuePrefix: "Totaled ",
        valueSuffix: "",
      });
    default: 
      return ({
        valuePrefix: "",
        valueSuffix: "",
    });
  }},[label]);
  return (
    <div>
      <Card ref={anchorEl}>
        <CardContent className={classes.Content}>
          <div>
            <Typography component="h5" variant="h5" noWrap>
              {label}
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" noWrap>
              {category}
            </Typography>
          </div>
          <div className={classes.Metrics}>
            <Typography component="h5" variant="h5" align="right" noWrap>
              {score}
            </Typography>
            <Typography variant="subtitle1" align="right" noWrap>
              {`${valuePrefix}${value.formatted ? value.formatted : value}${valueSuffix}`}
            </Typography>
          </div>       
        </CardContent>
        <CardActions>
          <Button 
            variant={chartsOpen ? "contained" : "text"}
            onClick={() => localDispatch({type: chartsOpen ? CLOSE_CHARTS : OPEN_CHARTS})}
            size={"small"}
            color="primary"
          >
            {"Chart"}
          </Button>
          <Button
            variant={breakdownOpen ? "contained" : "text"}
            onClick={() => localDispatch({type: breakdownOpen ? CLOSE_BREAKDOWN : OPEN_BREAKDOWN})}
            size={"small"}
            color="primary"
          >
            {"Breakdown"}
          </Button>
        </CardActions>
      </Card>
      <MPopper 
        {...{anchorEl}}
        id={"charts"} 
        open={chartsOpen}
        onClickAway={() => localDispatch({type: CLOSE_CHARTS})}
        useWidth
        useHeight
      >
        <MScorecardChart/>
      </MPopper>
      <MPopper
        {...{anchorEl}}
        id={"breakdown"}
        open={breakdownOpen}
        onClickAway={() => localDispatch({type: CLOSE_BREAKDOWN})}
        useWidth
        useHeight
      >
        <MScorecardBreakdown {...{metric}}/>
      </MPopper>
    </div>
  );
};

MScorecard.propTypes = {
  metric: PropTypes.object, //Definitions of this specific score
};

export default MScorecard;